// app/(lib)/actions/programsPageAction.ts
"use server";

import { programsPageService } from "../services/programsPageService";
import { extractDomain, getGlobalParams } from "../utils/domain";

/**
 * Fetch programs page content from API
 * Called once during SSR - data is passed down to all child components
 */
export async function getProgramsPageDataAction() {
  try {
    const domain = await extractDomain();
    const { franchiseeId, lang } = await getGlobalParams();

    const programsPageData = await programsPageService.fetchByDomain(domain, franchiseeId, lang);

    return {
      success: true,
      data: programsPageData,
    };
  } catch (error) {
    console.error("[getProgramsPageDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
